import ACCPSupervisorTableContainer from './ACCPSupervisorTableContainer';

export default ACCPSupervisorTableContainer;